import React, { useEffect } from 'react';

import './Error.css';

export const Error = ({ error }) => {
  useEffect(() => {}, []);

  return <div className='error-container'>{error}</div>;
};
